<template>
<div class="scrolly-content-video">
  <video v-for="index in attributes.p.length" :key="index" class="scrolly-looping-video" :id="index"
    :src="getVideoSource(index)"
    :style="getVideoStyle(index)"
    controlsList="nodownload"
    playsinline
    autobuffer
    autoplay
    loop
    muted
    :poster="getPosterSource(index)"
     />
</div>
</template>

<script>
export default {
  props: ['attributes', 'enter'],
  computed: {
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  mounted () {
    const originalPosition = 'absolute'
    const tempPosition = 'relative'
    var isVideoFlagged = false
//           const testtt = this.$el.getElementsByClassName('scrolly-looping-video')
// console.log(testtt)
    if (global.isMobile) {
      // force auto play intro video on low battery mode on mobile
      const vids = this.$el.getElementsByClassName('scrolly-looping-video');
      Array.from(vids).forEach(function (vid) {
      
      var events = ['click', 'touchstart']
      for (let i in events) {
        document.addEventListener(events[i], function (ev) {
          if (
            vid.autoplay && vid.currentTime > 0 && !vid.paused && !vid.ended && vid.readyState > 2
          ) {
            if (global.isIOS() && !isVideoFlagged) {
              isVideoFlagged = true
              vid.style.position = tempPosition
              setTimeout(() => {
                vid.style.position = originalPosition
              }, 500)
            }
            // is playing don't do anything
          } else if (vid.hasAttribute('loop')) {
            vid.play()
            vid.controls = false
            vid.removeAttribute('controls')
            if (global.isIOS()) {
              vid.style.position = tempPosition
              setTimeout(() => {
                vid.style.position = originalPosition
              }, 500)
            }
          }
        })
      }
    })
    }
  },
  methods: {

    getImagePath (index) {
      let [root, ext = 'jpg'] = this.attributes.value.split('.')
      return root + index + '.' + ext
    },
    getImageStyle (index) {
      return {
        opacity: index === 1 ? 1 : this.enter(index - 1, 200),
        // "z-index": index === 1 ? 1 : this.enter(index - 1, 200)
      }
    },
    
    getSource (index) {
      const {isTabletWidth, hasDesktopSource} = this
      let [path, ext = 'jpg'] = this.attributes.value.split('.')
      path += '/' + index + (!isTabletWidth && hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`images/${path}`)
    },
    getPosterSource (index) {
      const {isTabletWidth, hasDesktopSource} = this
      let [path, ext = 'jpg'] = this.attributes.poster.split('.')
      path += '/' + index + (!isTabletWidth && hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`videos/${path}`)
    },
    getVideoSource (index) {
      const {isTabletWidth, hasDesktopSource} = this
      let [path, ext = 'mp4'] = this.attributes.value.split('.')
      path += '/' + index + (!isTabletWidth && hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`videos/${path}`)
    },
    getVideoStyle (index) {
      return {
        opacity: index === 1 ? 1 : this.enter(index - 1, 200),
        "z-index" : this.enter(index - 1, 200),
      }
    },
  }
}
</script>

<style lang="scss">
.scrolly-content-video {
  // video {
  //   position: absolute;
  //   top: 50%;
  //   left: 0;
  //   transform: translateY(-50%);
  //   width: 100%;
  // }
    video {
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
  }
}
</style>
